import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    createDailySupply,
    updateDailySupply,
    deleteDailySupply,
    CreateDailySupplyBody,
    UpdateDailySupplyBody,
    DailySupplyResponse,
} from '../../services/apiSLTP/dailyReports/dailySupplies';

type UseCreateDailySupplyMutationOptions = MutationOptions<DailySupplyResponse, Error, CreateDailySupplyBody>;

export const useCreateDailySupplyMutation = (options?: UseCreateDailySupplyMutationOptions) => {
    const mutationFn: MutationFunction<DailySupplyResponse, CreateDailySupplyBody> = async (data) => {
        const response = await createDailySupply(data);
        return response;
    };

    return useMutation(mutationFn, options);
};

type UseUpdateDailySupplyMutationOptions = MutationOptions<DailySupplyResponse, Error, { id: string; data: UpdateDailySupplyBody }>;

export const useUpdateDailySupplyMutation = (options?: UseUpdateDailySupplyMutationOptions) => {
    const mutationFn: MutationFunction<DailySupplyResponse, { id: string; data: UpdateDailySupplyBody }> = async ({ id, data }) => {
        const response = await updateDailySupply(id, data);
        return response;
    };

    return useMutation(mutationFn, options);
};

type UseDeleteDailySupplyMutationOptions = MutationOptions<{ message: string }, Error, string>;

export const useDeleteDailySupplyMutation = (options?: UseDeleteDailySupplyMutationOptions) => {
    const mutationFn: MutationFunction<{ message: string }, string> = async (id) => {
        const response = await deleteDailySupply(id);
        return response;
    };

    return useMutation(mutationFn, options);
};
